import { axiosCall, axiosInstance } from "./axiosConfig";
import { axiosMethods, endPoints } from "../Models/api";
import { SiteModel, ZoneModel, HolidaysModel } from "../Models/settings";
import { AccountSettingsModel, UpdateFirmwareModel } from "../Models/account";
import { CancelToken } from "axios";
import { AccountAIEventSettingsModel } from "../Models/devices";
export const getAllSites = (includeDevices?: boolean) => {
  return axiosCall(axiosInstance, {
    url: endPoints.siteManagement + "/sites",
    method: axiosMethods.get,
    params: {
      includeDevices: includeDevices,
    },
  });
};
export const getAllTimeZones = () => {
  return axiosCall(axiosInstance, {
    url: endPoints.timezoneManagement + "/timezones",
    method: axiosMethods.get,
  });
};
export const addSite = (site: SiteModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.siteManagement + "/site",
    method: axiosMethods.post,
    data: {
      id: 0,
      name: site.name,
      timeZoneId: site.timezoneId,
      description: site.description,
    },
  });
};
export const deleteASite = (id: number) => {
  return axiosCall(axiosInstance, {
    url: endPoints.siteManagement + "/site/" + id,
    method: axiosMethods.delete,
  });
};
export const updateASite = (site: SiteModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.siteManagement + "/site",
    method: axiosMethods.put,
    data: {
      id: site.id,
      name: site.name,
      timeZoneId: site.timezoneId,
      description: site.description,
    },
  });
};

export const getTheSite = (id: number, includeDevices?: boolean) => {
  return axiosCall(axiosInstance, {
    url: endPoints.siteManagement + "/site/" + id,
    method: axiosMethods.get,
    params: {
      includeDevices: includeDevices,
    },
  });
};

/////////////
export const addZone = (zone: ZoneModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.zoneManagement + "/zone",
    method: axiosMethods.post,
    data: {
      id: 0,
      name: zone.name,
      description: zone.description,
      siteId: zone.siteId,
    },
  });
};
export const deleteAZone = (id: number) => {
  return axiosCall(axiosInstance, {
    url: endPoints.zoneManagement + "/zone/" + id,
    method: axiosMethods.delete,
  });
};
export const updateAZone = (zone: ZoneModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.zoneManagement + "/zone",
    method: axiosMethods.put,
    data: {
      id: zone.id,
      name: zone.name,
      description: zone.description,
    },
  });
};
export const getTheZone = (id: number) => {
  return axiosCall(axiosInstance, {
    url: endPoints.zoneManagement + "/zone/" + id,
    method: axiosMethods.get,
  });
};
export const getAllZones = () => {
  return axiosCall(axiosInstance, {
    url: endPoints.zoneManagement + "/zones",
    method: axiosMethods.get,
  });
};
//////////////
export const getHolidays = () => {
  return axiosCall(axiosInstance, {
    url: endPoints.holidaysManagement + "/holidays",
    method: axiosMethods.get,
  });
};
export const addHoliday = (holiday: HolidaysModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.holidaysManagement,
    method: axiosMethods.post,
    data: {
      id: 0,
      name: holiday.name,
      month: holiday.month,
      day: holiday.day,
    },
  });
};
export const updateHoliday = (holiday: HolidaysModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.holidaysManagement + "/holiday/" + holiday.id,
    method: axiosMethods.put,
    data: {
      id: holiday.id,
      name: holiday.name,
      month: holiday.month,
      day: holiday.day,
    },
  });
};
export const deleteAHoliday = (id: number) => {
  return axiosCall(axiosInstance, {
    url: endPoints.holidaysManagement + "/holiday/" + id,
    method: axiosMethods.delete,
  });
};

export const getAccountSettings = () => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/settings",
    method: axiosMethods.get,
  });
};

export const updateAccountName = (accountName: string) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account",
    method: axiosMethods.put,
    data: { name: accountName },
  });
};

export const updateAccountSettings = (accountSettings: AccountSettingsModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/settings",
    method: axiosMethods.put,
    data: accountSettings,
  });
};

export const getAccountCampaign = (token?: CancelToken) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/campaign",
    method: axiosMethods.get,
    cancelToken: token,
  });
};

export const upgradeFirmware = (data: UpdateFirmwareModel) => {
  return axiosCall(axiosInstance, {
    url: endPoints.customerSupportManagement + "/devices/firmware",
    method: axiosMethods.put,
    params: {
      isCampaign: true,
    },
    data,
  });
};

export const updateAccountEventSettings = (
  data: AccountAIEventSettingsModel,
  token?: CancelToken
) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/event-settings",
    method: axiosMethods.put,
    data,
    cancelToken: token,
  });
};

export const getAccountEventSettings = (token?: CancelToken) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/event-settings",
    method: axiosMethods.get,
    cancelToken: token,
  });
};

export const postSendSelfieEnrollmentBatch = (token?: CancelToken) => {
  return axiosCall(axiosInstance, {
    url: endPoints.accountManagement + "/account/batch-selfie-enroll",
    method: axiosMethods.post,
    cancelToken: token,
  });
};
